import { render, staticRenderFns } from "./AttachmentApplications.vue?vue&type=template&id=38d5b96c"
import script from "./AttachmentApplications.vue?vue&type=script&lang=js"
export * from "./AttachmentApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports